import * as React from "react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import { renderToStaticMarkup } from "react-dom/server";

const LIKELY_MARKDOWN_RE =
  /(^|\n)\s{0,3}(#{1,6}\s|[-*+]\s|\d+\.\s|>\s|```)|\*\*[^*\n]+\*\*|~~[^~\n]+~~|`[^`\n]+`|\[[^\]]+\]\([^)]+\)/m;

/**
 * Convert likely markdown text into sanitized HTML that TipTap can parse
 * into semantic nodes (headings/lists/etc) on insertion.
 */
export function renderMarkdownForTiptapInsert(
  markdown: string,
  { force = false }: { force?: boolean } = {},
): string | undefined {
  const source = String(markdown ?? "").trim();
  if (!source || (!force && !LIKELY_MARKDOWN_RE.test(source))) return undefined;

  try {
    const html = renderToStaticMarkup(
      React.createElement(
        ReactMarkdown,
        { remarkPlugins: [remarkGfm] },
        source,
      ),
    ).trim();
    return html || undefined;
  } catch {
    return undefined;
  }
}
